import {mapActions, mapGetters, mapMutations} from 'vuex';
import {camelCase} from 'lodash';

export default {
    name: 'lesson-tabs',
    props: {
        isBonus: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            active: this.isBonus ? 1 : 2,
            offsetTop: 0,
            isFixed: false,
            heightHeader: 0,
            heightFooter: 0,
            position: {
                left: 0,
                top: 0,
                bottom: 30
            }
        };
    },
    created() {
        this.fetchContent(this.$route.params).then(() => {
            Object.assign(this.seo, this.currentItem.seo.data)
            this.$emit('updateHead')
        })
    },
    computed: {
        ...mapGetters({
            selectedVideoId: 'coursesMaterials/selectedVideoId',
            currentItem: 'coursesMaterials/currentItem',
        }),
    },
    mounted() {
        if (window.innerWidth > 980 && this.$route.name !== 'courses-lesson-detail') {
            this.init()
            window.addEventListener('scroll', this.handleScroll)
            window.addEventListener('resize', this.setPositionSidebar)
        }
    },
    methods: {
        ...mapMutations({
            SET_VIDEO_ID: 'coursesMaterials/SET_VIDEO_ID'
        }),

        ...mapActions({
            fetchContent: 'coursesMaterials/FETCH_MATERIALS_ITEM',
        }),

        getCamelCase(text) {
            return camelCase(text);
        },

        changeChapter(video, chapter) {
            this.SET_VIDEO_ID(video.id);
            this.$bus.$emit('enter-chapter', {video, chapter})
        },

        onSelectVideo(video) {
            this.SET_VIDEO_ID(video.id);
        },

        init() {
            if (!document) return;
            this.offsetTop = this.trackingPositonElem(document.querySelector('.education-sidebar'))
            this.heightHeader = document.querySelector('.header-wrap')?.clientHeight || 52;
            this.heightFooter = document.querySelector('.footer')?.clientHeight || 68;

            this.setPositionSidebar()
        },
        setPositionSidebar() {
            this.position.left =
                document.querySelector('.education-sidebar').offsetLeft +
                document.querySelector('.education-wrap').offsetLeft + 15
            this.position.top = this.heightHeader
        },
        handleScroll(e) {
            const h = document.documentElement,
                st = 'scrollTop'
            const scrolled = (h[st]);
            this.isFixed = (scrolled + this.heightHeader) > this.offsetTop

            const bottomOfWindow = document.documentElement.scrollTop + window.innerHeight > document.documentElement.offsetHeight - this.heightFooter;
            if (bottomOfWindow) {
                if (document.querySelector('.video-providers') && document.querySelector('.video-providers').classList.contains('fixed')) {
                    this.position.bottom = Math.abs(((document.documentElement.offsetHeight) - (document.documentElement.scrollTop + window.innerHeight)) - this.heightFooter) + 30 + 220
                } else {
                    this.position.bottom = Math.abs(((document.documentElement.offsetHeight) - (document.documentElement.scrollTop + window.innerHeight)) - this.heightFooter) + 30
                }
            } else {
                if (document.querySelector('.video-providers') && document.querySelector('.video-providers').classList.contains('fixed')) {
                    this.position.bottom = 250
                } else this.position.bottom = 30
            }
        },
        trackingPositonElem(element) {
            let body = document.body,
                win = document.defaultView,
                docElem = document.documentElement,
                box = document.createElement('div');
            box.style.paddingLeft = box.style.width = '1px';
            body.appendChild(box);
            let isBoxModel = box.offsetWidth === 2;
            body.removeChild(box);
            box = element.getBoundingClientRect();
            let clientTop = docElem.clientTop || body.clientTop || 0,
                scrollTop = win.pageYOffset || isBoxModel && docElem.scrollTop || body.scrollTop;
            return box.top + scrollTop - clientTop;
        },
    }
}
